<template>
  <div class="character">
    <!-- 基础数据 -->
    <div class="avatar">
      <img :src="dataSource.avatar.value" alt="" />
    </div>
    <div class="info">
      <div class="top">
        <div class="name">
          {{ dataSource.name.value }}
        </div>
        <div class="stars">
          <img
            src="@/assets/zs_imgs/star-icon.png"
            v-for="i in parseInt(dataSource.stars.value.toString().replace(/[^\d]/g, '') || '0')"
            :key="i"
          />
        </div>
      </div>
      <div class="bottom">
        <div class="attr attr1">
          <img :src="dataSource.attr1.icon.value" alt="" />
          <span>{{ dataSource.attr1.name.value }}</span>
        </div>
        <div class="attr attr1">
          <img :src="dataSource.attr2.icon.value" alt="" />
          <span>{{ dataSource.attr2.name.value }}</span>
        </div>
        <div class="attr attr2">
          <img :src="dataSource.attr3.icon.value" alt="" />
          <span>{{ dataSource.attr3.name.value }}</span>
        </div>
        <div class="attr attr2">
          <img :src="dataSource.attr4.icon.value" alt="" />
          <span>{{ dataSource.attr4.name.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.character {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding-top: 4px;
  padding-bottom: 14px;
  margin-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  .avatar {
    align-self: flex-start;
    width: 67px;
    height: 90px;
    background: #36254a;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .info {
    flex: 1;
    width: 100%;
    padding-top: 25px;
    .top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;
      .name {
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 16px;
      }
      .stars {
        display: flex;
        align-items: center;
        gap: 5px;
        min-width: 12px;
        height: 12px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .attr {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 12px;
        color: #a6a6a6;
        white-space: nowrap;
        overflow: hidden;
        img {
          width: 28px;
          height: 28px;
          margin-right: 6px;
        }
      }
      // .attr1 {
      //   img {
      //     width: 18px;
      //     height: 18px;
      //     margin-right: 6px;
      //   }
      // }
    }
  }
}
</style>
